export function shouldTypographyTagRender() {
  const { value, type, isDefault } = this.state

  if (
    !value ||
    !type ||
    (type !== 'ratio' && type !== 'range' && type !== 'base')
  ) {
    return false
  }

  if (isDefault) {
    return Boolean(value)
  }

  const typography = this.getDesignSystem('typography')

  if (!Number.isNaN(Number(value))) {
    return value !== typography[type]
  }

  if (value.includes('px') && type === 'base') {
    return Number(value.replace('px', '')) !== typography[type]
  }

  if (value.includes(',') && type === 'range') {
    return value !== typography[type]?.join(', ')
  }

  return false
}

export async function createTypography() {
  if (!this.node.elements) {
    console.warn('createTypography must be used inside a Form')
    return
  }
  const cleanedKey = this.call(
    'handleAtKey',
    this.node.elements.item('sidebar-new-item').value
  )

  const defaultValue = this.getDesignSystem('typography')
  await this.updateDesignSystem(`typography.${cleanedKey}`, {
    base: defaultValue.base ?? 16,
    ratio: defaultValue.ratio ?? 1.25,
    range: defaultValue.range ?? [-5, 12],
    subSequence: defaultValue.subSequence ?? true
  })
}
